// extracted by mini-css-extract-plugin
export default {"textBlock":"TextBlock_textBlock__oE1rA","mobile":"TextBlock_mobile__b3Q6N","title":"TextBlock_title__GqEIL","text":"TextBlock_text__kZ-ys"};